import { formatCurrency } from '@/utils/number-functions';

const currencyPropsFunc = (record, column) => {
	return {
		value: record[column.columnName] || 0,
		formatter: formatCurrency,
		zeroDisplay: '-'
	};
};

const currencyComponentDef = {
	name: 'NumberDisplay',
	props: currencyPropsFunc
};

export default [
	{
		columnName: 'id',
		columnDisplayName: 'OpCode Model Id',
		display: false
	},
	{
		columnName: 'vehicleMakeModel',
		columnDisplayName: 'Make/Model',
		columnModifierName: 'make-model',
		display: true
	},
	{
		columnName: 'vehicleDescription',
		columnDisplayName: 'Description',
		columnModifierName: 'description',
		display: true
	},
	{
		columnName: 'laborHours',
		columnDisplayName: 'Labor Hrs',
		columnModifierName: 'labor-hrs',
		display: true
	},
	{
		columnName: 'laborRate',
		columnDisplayName: 'Rate',
		columnModifierName: 'rate',
		display: true,
		component: currencyComponentDef
	},
	{
		columnName: 'laborAmount',
		columnDisplayName: 'Amount',
		columnModifierName: 'amount',
		display: true,
		component: currencyComponentDef
	},
	{
		columnName: 'fixedPrice',
		columnDisplayName: 'Fixed Price',
		columnModifierName: 'fixed-price',
		display: true,
		component: currencyComponentDef
	}
];
